import moment from 'moment';
import { DeviceSummaryAttribute } from '../constants/telosair-interfaces';

/**
 * The backend fills a device (or group, or the whole client) that reported
 * nothing in the selected window with its last known reading and flags it
 * `stale`. These helpers keep every dashboard view rendering that case the same
 * way: the old value is still shown, but in grey and never with a status colour.
 */

/** Text colour for a value that is a last known reading, not a live one. */
export const STALE_TEXT_CLASS = 'text-gray-500';

/** Badge / marker fill for a stale reading. */
export const STALE_BG_CLASS = 'bg-gray-500';

/** Hex used where a colour is set inline rather than by class. */
export const STALE_HEX = '#6B7280';

/**
 * Whether a summary entry is a stale fallback rather than data from the window.
 * @param summary - Device or group summary from the API.
 * @returns True when the values are last known readings.
 */
export function isSummaryStale(summary: DeviceSummaryAttribute | null | undefined): boolean {
  return summary?.stale === true;
}

/**
 * Human-readable "last reported" caption for a stale reading.
 * @param timeStamp - Epoch millis of the last known reading, if any.
 * @returns Caption such as "Last reported 12 Sep, 14:03" or a generic fallback.
 */
export function lastReportedLabel(timeStamp?: number | null): string {
  if (!timeStamp) return 'Last known reading';
  const when = moment(timeStamp);
  const sameYear = when.year() === moment().year();
  return `Last reported ${when.format(sameYear ? 'D MMM, HH:mm' : 'D MMM YYYY, HH:mm')}`;
}
